import { CheckCircle2 } from "lucide-react";

const points = [
  "Cosmetic Registered Nurse",
  "Fully trained & certified",
  "3 years dedicated experience",
  "Evidence-based, personalised plans",
];

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="py-24 sm:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          <div className="lg:col-span-6 reveal">
            <div className="relative">
              <div className="absolute -inset-6 bg-[#F5ECE1] rounded-[28px] -z-10" />
              <img
                src="/brand/about-practitioner.jpg"
                alt="Nurse Dimi at Face It Aesthetics"
                className="w-full h-[520px] object-cover rounded-3xl"
              />
              <div className="absolute -top-5 left-2 right-2 sm:left-[-1rem] sm:right-auto sm:max-w-[260px] bg-white border border-[#E8E1DA] rounded-2xl shadow-sm px-4 py-3.5">
                <p className="overline" style={{ fontSize: "0.62rem" }}>
                  Compliance & Care
                </p>
                <p className="font-sans-luxe text-[11px] leading-[1.55] mt-1.5 text-[#2C2723]">
                  Every patient receives an individualised consultation prior to
                  treatment. Prescription medicines are administered in
                  accordance with relevant state and national regulations,
                  ensuring the highest standard of patient safety and ethical
                  care.
                </p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-6 reveal" style={{ transitionDelay: "150ms" }}>
            <p className="overline">About the Practitioner</p>
            <h2 className="font-serif-luxe mt-5 text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.02] text-[#2C2723]">
              Qualified, experienced,
              <br />
              and here to help you achieve your{" "}
              <em className="text-[#8C6A53]">aesthetic</em> goals.
            </h2>
            <p className="mt-8 text-[15px] leading-relaxed text-[#5C534B] max-w-xl">
              Hi, I&rsquo;m Dimi. I&rsquo;m a fully trained, AHPRA-registered
              cosmetic nurse based in Belmore, New South Wales. With three years
              of hands-on experience in aesthetic medicine, I approach every
              consultation with clinical precision and a genuine commitment to
              your wellbeing and natural results.
            </p>
            <p className="mt-5 text-[15px] leading-relaxed text-[#5C534B] max-w-xl">
              I commenced my career in cosmetic nursing at Evolution Laser
              Clinic, where I developed into a proficient cosmetic injector and
              refined my clinical techniques across a broad range of aesthetic
              treatments. During my time there, I was recognised with several
              awards and had the privilege of being mentored and trained by some
              of the industry&rsquo;s most renowned healthcare practitioners.
            </p>
            <p className="mt-5 text-[15px] leading-relaxed text-[#5C534B] max-w-xl">
              At Face It Aesthetics, all treatments involving prescription
              medicines are performed under appropriate medical governance, in
              full compliance with TGA and AHPRA regulatory requirements. Your
              safety is always my priority.
            </p>

            <ul className="mt-10 grid sm:grid-cols-2 gap-4 max-w-xl">
              {points.map((p) => (
                <li
                  key={p}
                  className="flex items-start gap-3 text-sm text-[#2C2723]"
                  data-testid={`about-point-${p.split(" ")[0].toLowerCase()}`}
                >
                  <CheckCircle2
                    size={18}
                    className="mt-0.5 text-[#8C6A53] flex-shrink-0"
                  />
                  {p}
                </li>
              ))}
            </ul>

            <a
              href="#contact"
              data-testid="about-cta"
              className="mt-10 inline-flex items-center gap-2 text-sm tracking-wide text-[#2C2723] border-b border-[#2C2723] pb-1 hover:text-[#8C6A53] hover:border-[#8C6A53] transition-colors"
            >
              Begin your consultation
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
